module.exports = __webpack_public_path__ + "static/img/ic_play.63e513a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ic_play.png
// module id = 255
// module chunks = 0